module.exports = __webpack_public_path__ + "img/share-icon-ios.455a396b.svg";